import React from 'react';
import Sidebar from "../sidebar";
import Navbar from "../navbar";
import { Routes, Route } from 'react-router-dom';
import MenuList from './MenuList';
import AddMeal from './addMeal';
import EditMeal from './editMeal';

function Menu() {
    return (
        <div className="min-h-screen flex bg-[#F9F9F9]">
            <div className="fixed lg:relative lg:flex">
                <Sidebar />
            </div>
            <div className="flex-1">
                <Navbar />
                <div className="flex-1 ml-0 lg:ml-64 p-4">
                    <Routes>
                        <Route path="/" element={<MenuList />} />
                        <Route path="/add" element={<AddMeal />} />
                        <Route path="/edit/:id" element={<EditMeal />} />
                    </Routes>
                </div>
            </div>
        </div>
    );
}
export default Menu;